import { CHART_HEIGHTS } from './heights';
import { CHART_SPACING } from './spacing';

export type ChartTokens = Readonly<{
  heights: typeof CHART_HEIGHTS;
  spacing: typeof CHART_SPACING;
}>;

export const CHART_TOKENS: ChartTokens = {
  heights: CHART_HEIGHTS,
  spacing: CHART_SPACING,
};

export { CHART_HEIGHTS } from './heights';
export { CHART_SPACING } from './spacing';
export * from './muiChartLayout';
